import { NgClass } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss']
})
export class ButtonComponent {
  @Input() customClass:NgClass;
  @Input() svgName:string;
  @Input() buttonLabel:string;
  @Input() buttonId:string;
  @Input() download :boolean = false;
  @Input() disabled :boolean = false;

}
